import { render, staticRenderFns } from "./EducationCostBearerPaymentRequestPreview.vue?vue&type=template&id=752b4c4e"
import script from "./EducationCostBearerPaymentRequestPreview.vue?vue&type=script&lang=ts"
export * from "./EducationCostBearerPaymentRequestPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports